const ALLOWED_UPLOAD_TYPES = new Set([
  'image/jpeg', 'image/png', 'image/webp', 'image/gif', 'application/pdf',
]);
const ALLOWED_HERO_VIDEO_TYPES = new Set(['video/mp4', 'video/webm']);
const STANDARD_UPLOAD_LIMIT = 10 * 1024 * 1024;
const HERO_VIDEO_UPLOAD_LIMIT = 25 * 1024 * 1024;

export function validateAssetUpload(file, { heroVideo = false } = {}) {
  const allowedTypes = heroVideo ? ALLOWED_HERO_VIDEO_TYPES : ALLOWED_UPLOAD_TYPES;
  const maxSize = heroVideo ? HERO_VIDEO_UPLOAD_LIMIT : STANDARD_UPLOAD_LIMIT;
  if (!file || !allowedTypes.has(file.type) || (!heroVideo && /\.svgz?$/i.test(file.name))) {
    throw new Error(heroVideo
      ? 'Envie um vídeo MP4 (H.264) ou WebM.'
      : 'Envie uma imagem (JPG, PNG, WebP ou GIF) ou um arquivo PDF. SVG não é permitido.');
  }
  if (file.size > maxSize) {
    throw new Error(heroVideo
      ? 'O vídeo deve ter no máximo 25 MB.'
      : 'O arquivo deve ter no máximo 10 MB.');
  }
}
